<template>
  <div>
    <b-modal
      id="add-campaign"
      ref="modal"
      header-class="headerModal"
      no-close-on-backdrop
      centered
      size="lg"
      :title="$t('Add Campaign')"
      hide-footer
    >
      <b-form class="p-2">
        <b-row>
          <b-col md="6">
            <b-form-group
              label-for="input-1"
              :state="validateState('campaign')"
              :invalid-feedback="$t('Field is required')"
            >
              <template #label>
                {{ $t('Campaign Name') }} <span class="text-danger">*</span>
              </template>
              <b-form-input
                id="input-1"
                v-model="$v.form.campaign.$model"
                :state="validateState('campaign')"
                :placeholder="$t('Campaign Name')"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label-for="input-2"
              :state="validateState('campaignType')"
              :invalid-feedback="$t('Field is required')"
            >
              <template #label>
                {{ $t('Campaign type') }} <span class="text-danger">*</span>
              </template>
              <vue-select
                id="input-2"
                v-model="$v.form.campaignType.$model"
                :options="campaignTypes"
                :placeholder="$t('Campaign type')"
                :class="{ 'is-invalid': validateState('campaignType') === false }"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              :state="validateState('time1')"
              :invalid-feedback="$t('Field is required')"
            >
              <template #label>
                {{ $t('StartDate') }} <span class="text-danger">*</span>
              </template>
              <date-picker
                v-model="$v.form.time1.$model"
                @change="handleStartChange"
                type="date"
                value-type="format"
                :placeholder="$t('SelectD')"
                :format="'DD-MM-YYYY'"
                width="100%"
                :input-class="validateState('time1') === false ? 'mx-input is-invalid' : 'mx-input'"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group 
              :state="validateState('time2')" 
              :invalid-feedback="$t('Field is required')"
            >
              <template #label>
                {{ $t('EndDate') }} <span class="text-danger">*</span>
              </template>
              
              <date-picker
                v-model="$v.form.time2.$model"
                type="date"
                value-type="format"
                :placeholder="$t('SelectD')"
                :format="'DD-MM-YYYY'"
                width="100%"
                :input-class="validateState('time2') === false ? 'mx-input is-invalid' : 'mx-input'"
                :disabled-date="disableDateBeforeStart"
              />
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group :label="$t('Campaign Budget')">
              <b-form-input
                v-model="form.Budget"
                type="number"
                :placeholder="$t('Budget')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              :state="validateState('campaignOccassion')"
              :invalid-feedback="$t('Field is required')"
            >
              <template #label>
                {{ $t('Campaign Occasion') }} <span class="text-danger">*</span>
              </template>
              <vue-select
                v-model="$v.form.campaignOccassion.$model"
                :options="campaigns"
                :placeholder="$t('Campaign Occasion')"
                :class="{ 'is-invalid': validateState('campaignOccassion') === false }"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <div class="buttonsEverywhere" style="margin-top: 20px;">
          <button
            type="button"
            class="buttonSubmit"
            @click="onSubmit"
          >
            {{ $t('Submit') }}
          </button>
          <b-button
            type="button"
            variant="danger"
            class="buttonCancel"
            style="margin-right: 15px; background: white; color: black; border-color: white; font-weight: 400;"
            @click="onCancel"
          >
            {{ $t('Cancel') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';

// 1. IMPORT validationMixin AND required
import { validationMixin } from 'vuelidate' 
import { required } from 'vuelidate/lib/validators';

export default {
  components: {
    DatePicker,
  },
  mixins: [validationMixin], 

  validations: {
    form: {
      campaign: { required },
      campaignType: { required },
      time1: { required },
      time2: { required },
      campaignOccassion: { required },
    }
  },
  props: [],
  data() {
    return {
      form: {
        campaign: null,
        time1: null,
        time2: null,
        Budget: null,
        campaignOccassion: null,
        campaignType: null,
      },
      campaigns: [],
      campaignTypes: ['Email', 'Phone', 'Social Media', 'Fashion Week', 'Workshop', 'Black Friday', 'Other'],
    }
  },
  mounted() {
    if (this.$store && this.$store.dispatch) {
      this.$store.dispatch('fetchCampaignOccasions')
        .then((res) => {
          if (Array.isArray(res)) {
            this.campaigns = res.map((r) => ({ label: r.name || r.value || r.displayName || r.description || r.lovCampaignOccasionName || r.lovCampaignOccasionId, value: r.lovCampaignOccasionId || r.id || r.value }));
          }
        })
        .catch(() => {});
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    disableDateBeforeStart(date) {
    if (!this.form.time1) {
      return false;
    }
    const startDate = moment(this.form.time1, 'DD-MM-YYYY').startOf('day');
    return moment(date).isBefore(startDate);
  },
  // In methods
handleStartChange() {
  // If we have both dates, and End is now before Start, clear End
  if (this.form.time1 && this.form.time2) {
    const start = moment(this.form.time1, 'DD-MM-YYYY');
    const end = moment(this.form.time2, 'DD-MM-YYYY');
    if (end.isBefore(start)) {
      this.form.time2 = null;
    }
  }
},
    onSubmit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const payload = {
        name: this.form.campaign,
        type: this.form.campaignType,
        startTime: this.form.time1
          ? moment(this.form.time1, 'DD-MM-YYYY').toISOString()
          : null,
        endTime: this.form.time2
          ? moment(this.form.time2, 'DD-MM-YYYY').toISOString()
          : null,
        lovCampaignOccasionId:
          this.form.campaignOccassion?.value ||
          this.form.campaignOccassion?.lovCampaignOccasionId ||
          null,
        Budget: this.form.Budget,
      }

      this.$emit('addCampaign', payload)
      this.$refs.modal.hide()
      this.resetForm()
    },
    onCancel() {
      this.$refs.modal.hide()
      // Use nextTick to ensure the modal is hidden before resetting validation state
      this.$nextTick(() => {
        this.resetForm()
        this.$v.$reset()
      })
    },
    resetForm() {
      this.form.campaignOccassion = null
      this.form.Budget = null
      this.form.time1 = null
      this.form.time2 = null
      this.form.campaign = null
      this.form.campaignType = null
      // Ensure validation is reset after clearing values
      this.$nextTick(() => {
         this.$v.$reset()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  form {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .deactivate-modal__select {
    display: flex;
    flex-direction: column;
    select {
      margin-bottom: 10px;
      padding: 10px;
    }
    button {
      align-self: end;
    }
  }
  .flex-form {
    display: flex;
    flex-direction: column;
  }
  
  // Custom styling to handle red border on vue-select when invalid
  ::v-deep .is-invalid .vs__dropdown-toggle {
    border-color: #dc3545;
  }

  ::v-deep .mx-datepicker {
    width: 100% !important;
  }
  
  // Styling for the datepicker input when invalid
  ::v-deep .mx-input.is-invalid {
     border-color: #dc3545;
  }
</style>